import gql from "graphql-tag";

export default gql`
  query RequestCompanyIssuerWithTranslatedDescription(
    $input: [CompanyIssuerSearchRefInput!]!
    $language: ISO6391LanguageCode!
    $descriptionLanguages: [ISO6391LanguageCode!] = ["en", "pt"]
  ) {
    companyIssuers(input: $input) {
      _id
      description(language: $language)
      descriptionTranslations(languages: $descriptionLanguages) {
        _id
        objectId
        language
        textContent
      }
    }
  }
`;
